import { render, staticRenderFns } from "./DialogPush.vue?vue&type=template&id=4585f1bc&scoped=true"
import script from "./DialogPush.vue?vue&type=script&lang=js"
export * from "./DialogPush.vue?vue&type=script&lang=js"
import style0 from "./DialogPush.vue?vue&type=style&index=0&id=4585f1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585f1bc",
  null
  
)

export default component.exports